import React from 'react';
import './Sections.scss';

function Section5() {
  return (
    <section className="sections sections-section5">
      <p className="sections-copy">
        Freed from the need to live near the shortest and most practical route to work, buyers are
        expanding their home search into locations where they would not have looked before. In some
        cases, remote or flexible work has given buyers the freedom to move to a different city or
        state to be closer to friends and family, find a more affordable metro area, or pursue a
        dream of living in a new part of the country. In 2022, the median distance for such moves
        was 50 miles—a distance much greater than the historical norm. These migratory trends are
        reflected in NAR’s interactive map on{' '}
        <a
          className="hyperLink"
          href="https://sponsorcontent.cnn.com/interactive/nar/map/"
          target="_blank"
          rel="sponsored"
        >
          The State of Housing in America
        </a>{' '}
        that shows where housing demand is rising fastest across the country.
      </p>
    </section>
  );
}

export default Section5;
